import { create } from 'zustand';
import { DesignFloorPlan, FloorPlanPoint } from '../types';

export type HoverRoomPreview = {
  polygon: FloorPlanPoint[];
  wallIds: string[];
} | null;

interface LiveFloorPlanState {
  plan: DesignFloorPlan | null;
  hoverRoomPreview: HoverRoomPreview;
  setPlan: (plan: DesignFloorPlan | null) => void;
  setHoverRoomPreview: (preview: HoverRoomPreview) => void;
}

/**
 * Ephemeral floor-plan overlay used during wall drag / room hover.
 * Kept off the main project store so sidebars and equipment do not re-render
 * on every pointermove.
 */
export const useLiveFloorPlanStore = create<LiveFloorPlanState>((set) => ({
  plan: null,
  hoverRoomPreview: null,
  setPlan: (plan) => set({ plan }),
  setHoverRoomPreview: (hoverRoomPreview) => set({ hoverRoomPreview }),
}));
